import { Icon } from "@iconify/react";

const Input = ({
  type,
  variant,
  label,
  placeholder,
  icon,
  disabled,
  containerClassName,
  inputClassName,
  value,
  onChange,
}) => {
  const getVariantClasseNames = () => {
    let containerBaseClassName =
      "flex flex-row items-center overflow-hidden gap-[13px] py-3 lg:px-[25px] px-5 transition-all duration-300 ";
    let inputBaseClassName =
      "flex-1 outline-none border-none bg-transparent line-clamp-1 lg:text-[20px] text-base ";
    switch (variant) {
      case "white-blur":
        containerBaseClassName +=
          "bg-white-blur-02 rounded-[15px] border border-transparent hover:border-white focus-within:border-white ";
        inputBaseClassName += "text-white placeholder:text-white ";
        break;
      case "hero-glass":
        /* Figma: Frame 1321318097/8098 — padding 12px 25px, 60px row, 20px / 30px text */
        containerBaseClassName +=
          "bg-[rgba(255,255,255,0.15)] rounded-[15px] border border-transparent hover:border-white/40 focus-within:border-white/50 min-h-[60px] !py-3 !px-[25px] ";
        inputBaseClassName +=
          "text-white placeholder:text-white/95 text-base leading-[30px] sm:text-[20px] sm:leading-[30px] ";
        break;
      case "primary-solid":
        containerBaseClassName += "border-[1.5px] border-[#91ADFF] bg-white ";
        inputBaseClassName += "text-[#4E5E6F] placeholder:text-[#4E5E6F] ";
        break;
      case "default":
        containerBaseClassName = "border border-[#1B51EC33] rounded-lg p-2 ";
        inputBaseClassName =
          "border-none bg-transparent outline-none text-dark-blue text-sm ";
        break;
    }

    containerBaseClassName += ` ${containerClassName ?? ""}`;
    inputBaseClassName += ` ${inputClassName ?? ""}`;
    return { containerBaseClassName, inputBaseClassName };
  };

  const getIconClassNames = () => {
    let baseClassName = "lg:w-7 lg:h-7 w-5 h-5 ";

    switch (variant) {
      case "white-blur":
        baseClassName += "text-white ";
        break;
      case "hero-glass":
        baseClassName += "text-white ";
        break;

      case "default":
        baseClassName = "text-[#25347799] w-4 h-4";
    }
    return baseClassName;
  };

  return (
    <div className={getVariantClasseNames().containerBaseClassName}>
      {icon && <Icon icon={icon} className={getIconClassNames()} />}
      <input
        type={type ?? "text"}
        placeholder={placeholder}
        className={getVariantClasseNames().inputBaseClassName}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default Input;
